<template>
  <div class="page">
    <!--    style="background-color: #00bfa5"-->

    <v-container grid-list-xl v-if="news.length <1">
      <h3 class="mt-7 text-center">Es gibt zur Zeit keine Neuigkeiten</h3>
    </v-container>

    <v-container grid-list-xl v-else>
      <h2 class="mt-5 mb-5">Aktuelles</h2>

      <!--      <CmsBlock blockName="Stellenangebote"></CmsBlock>-->

      <div class="invisible all">{{ news }}</div>

      <v-layout row wrap v-if="!loaded">
        <v-flex xs12 sm6 lg4 v-for="n in 3">
          <v-skeleton-loader
            class="mx-auto"
            max-width="600"
            type="image, article"
          ></v-skeleton-loader>
        </v-flex>
      </v-layout>

      <v-layout row wrap v-else>
        <v-flex xs12 sm6 lg4 v-for="n in news" v-if="news.length > 0">
          <NewsCard @click.native.passive="gotoBeitrag(n)" class="news-card pointer" :data-key="n.id"
                    :news="n"></NewsCard>
        </v-flex>
        <v-flex xs12 v-else>
          <h3 class="mt-5">Es gibt zur Zeit keine Neuigkeiten</h3>
        </v-flex>
      </v-layout>

    </v-container>
  </div>
</template>

<script>
import {ebus} from '@/vendor/ebus';
import store from "@/store/store";
import {cloneMe} from "@/vendor/util";
import NewsCard from "@/news/NewsCard.vue";
import {getCurrentDevice} from "@/vendor/breakpoints";


export default {
  name: "Stellenangebote",
  components: {NewsCard},
  data() {
    return {
      loaded: false,
      // currentTag: '',
    }
  },
  computed: {
    news() {
      if (!this.$store.state.enableNews) {
        return;
      }

      let news = cloneMe(store.getters.news);

      if (getCurrentDevice() !== 'xs') {
        news.forEach(n => {
          if (!n.image) {
            n.image = require('@/assets/placeholder6-opti.png');
          }
        })
      }

      //sort by publishDate
      let ordered = news.sort((a, b) => b.publishDate - a.publishDate);

      if (ordered.length > 0) {
        this.loaded = true;
      }
      return ordered;
    }
  },
  mounted() {
    setTimeout(() => {
      ebus.$emit('loadNews');
    }, 200)

    setTimeout(() => {
      ebus.$emit('triggerPushQuestion');
    }, 3000);
  },
  methods: {
    gotoBeitrag(news) {
      this.$router.push({name: 'Nachricht', params: {newsId: news.id}});
    },
  }
}
</script>

<style scoped lang="scss">

</style>
